import { Button, Grid, Typography } from "@material-ui/core";
import { LastTemplateModel, LastTemplateType, loadLastTemplate } from "../../services/LastMailTemplateService";



const LastTemplate: React.FC<{ updateMailBodyParent: (lastMessage: LastTemplateModel) => void, type:LastTemplateType }> = ({ updateMailBodyParent, type }) => {

    const loadLastSentTemplate = async () => {
        const foundTemplate:LastTemplateModel | null = await loadLastTemplate(type);
        if(foundTemplate)
            updateMailBodyParent(foundTemplate);
    }

    return (
        <Grid container item xs={12} className="container-buttons-message">
            <Button variant="contained" component="label" className="last-template-button" onClick={loadLastSentTemplate}>
                <Typography variant="h5" className="regular-serif">
                    Cargar último mensaje enviado
                </Typography>
            </Button>
        </Grid>);
}

export default LastTemplate;